;(() => {
  const tabNavClass = "tab-nav"
  const tabNavOpenClass = "tab-nav--open"
  const tabNavItemClass = "tab-nav__item"
  const tabNavItemActiveClass = "tab-nav__item--active"
  const tabItemActiveClass = "tabs__item--active"

  function showTab(tabId, withScroll) {
    const tab = document.getElementById(tabId)
    const tabLink = document.querySelector(`[data-tab="${tabId}"]`)
    const tabNav = tabLink.closest(`.${tabNavClass}`)

    if (!tab || !tabNav) {
      return
    }

    if (tab.classList.contains(tabItemActiveClass)) {
      tabNav.classList.toggle(tabNavOpenClass)
    } else {
      for (const activeTab of tab
        .closest(".tabs")
        .querySelectorAll(`.${tabItemActiveClass}`)) {
        activeTab.classList.remove(tabItemActiveClass)
      }

      for (const activeLink of tabLink
        .closest(`.${tabNavClass}`)
        .querySelectorAll(`.${tabNavItemActiveClass}`)) {
        activeLink.classList.remove(tabNavItemActiveClass)
      }

      tab.classList.add(tabItemActiveClass)
      tabLink
        .closest(`.${tabNavItemClass}`)
        .classList.add(tabNavItemActiveClass)
      tabNav.classList.remove(tabNavOpenClass)
    }

    if (withScroll) {
      window.scrollTo(0, tab.offsetTop - 120)
    }
  }

  window.showTab = showTab

  function initTabs() {
    const tabNav = document.querySelector(`.${tabNavClass}`)

    if (!tabNav) {
      return
    }

    const tabLinks = document.querySelectorAll("[data-tab]")

    for (const tabLink of tabLinks) {
      tabLink.addEventListener("click", (e) => {
        e.preventDefault()

        showTab(tabLink.dataset.tab, !!tabLink.dataset.scroll)
      })
    }

    document.addEventListener("click", (e) => {
      const isClickInside = tabNav.contains(e.target)

      if (!isClickInside) {
        tabNav.classList.remove(tabNavOpenClass)
      }
    })
  }

  window.addEventListener("load", () => {
    initTabs()
  })
})()
